// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BinocularsIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.65 18.984a5.892 5.892 0 0 0-.294-.682L24.157 6.475a.978.978 0 0 0-.207-.305 4 4 0 0 0-5.657 0 1 1 0 0 0-.293.705V10h-4V6.875a1 1 0 0 0-.293-.707 4 4 0 0 0-5.657 0 .978.978 0 0 0-.208.304L2.644 18.3A6 6 0 1 0 14 21v-9h4v9a6 6 0 1 0 11.65-2.016ZM9.589 7.469A2 2 0 0 1 12 7.344v9.188a5.987 5.987 0 0 0-5.849-1.24L9.59 7.47ZM8 25a4 4 0 1 1 0-8 4 4 0 0 1 0 8ZM20 7.343a2 2 0 0 1 2.411.125l3.438 7.822A5.987 5.987 0 0 0 20 16.531V7.343ZM24 25a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
